import { createFileRoute, redirect } from '@tanstack/react-router';

// Đã chuyển sang mục Lưu trữ; giữ đường cũ để link và dấu trang vẫn mở được.
export const Route = createFileRoute('/_authenticated/settings/history/')({
  beforeLoad: () => { throw redirect({ to: '/archive/history', replace: true }); },
});
